import { Plugins } from '@leverege/plugin';
function processor(extensions) {
  const ids = new Map();
  for (let i = 0; i < extensions.length; i++) {
    const extension = extensions[i];
    const byId = ids.get(extension.id);
    if (byId == null && extension.id != null) {
      ids.set(extension.id, extension);
    }
  }
  return {
    ids
  };
}
const view = Plugins.createView('TiptapExtension', {
  processor
});
function getById(id) {
  const {
    ids
  } = view.get();
  return ids.get(id);
}
function getAll() {
  const {
    ids
  } = view.get();
  return Array.from(ids.values());
}
function configureAll(options) {
  const all = getAll();
  return all.map(ext => ext.extension.configure(options));
}
export default {
  getById,
  getAll,
  configureAll
};